import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";


const Tutorial = ({ location }) => {
  const { pathname } = location;
  var strings = require("../../translations/italian.json");

  var informazioni = global.informazioni
  /*switch(global.aziendaID)
  {
    case 1: 
      informazioni = informazioniDGA
      break;
    case 2:
      informazioni = informazioniMondoCarta
      break;
  }*/
  return (
    
    <Fragment>
      <MetaTags>
        <title>{strings.tutorial} | {informazioni.società}</title>
          <meta
            name="description"
            content= {strings.tutorial + " " + informazioni.società}
          />
      </MetaTags>


      <LayoutOne>
        {/* breadcrumb */}
        <Breadcrumb />
          <div
        className={`welcome-area`}
      >
        <div className="container">
        <div className="welcome-content text-center" >
        <h1>Tutorial</h1>
        <p>Vuoi scoprire tutte le <strong>funzionalità</strong> del nostro sito? Guarda il nostro <strong>tutorial</strong>!<br/> In pochi minuti ti mostreremo come <strong>navigare</strong> al meglio, fare <strong>acquisti</strong> in modo facile e sfruttare tutti i <strong>vantaggi</strong> che offriamo.<br/> Non perdere questa occasione per migliorare la tua <strong>esperienza online</strong>!
        </p>
        <br/>
        <br/>
        <br/>
        <iframe width="1000" height="562" src="https://www.youtube.com/embed/kX-PiY1Juzs?rel=0&vq=hd1080" title="Tutorial" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br/>
        <br/>
        <br/>
        </div>
        </div>
        </div>
        
       
      </LayoutOne>
    </Fragment>
  );
};

Tutorial.propTypes = {
  location: PropTypes.object
};

export default Tutorial;
